import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {Alert} from '../../../delivery/models/alert.model';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-alerts-widget',
	templateUrl: './alerts-widget.component.html',
	styleUrls: ['./alerts-widget.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class AlertsWidgetComponent {
	@Input() alerts: any[];
	@Input() readonly: boolean;

	@Output() onClickAlertEventEmitter: EventEmitter<Alert> = new EventEmitter<Alert>();
	@Output() goToAlertDetailsEventEmitter: EventEmitter<Event> = new EventEmitter<Event>();
	@Output() goToWriteNewAlertEventEmitter: EventEmitter<Event> = new EventEmitter<Event>();

	translateContext = TranslateContext;
}
